import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { useEffect, useState } from 'react';
import { setApiDeviceId } from '@/utils/ky';

// In-memory backup during session
let memoryDeviceId: string | null = null;

// Try to load device ID synchronously to make it available immediately
try {
  memoryDeviceId = localStorage.getItem('device_id');
  if (memoryDeviceId) {
    console.log('Device ID loaded synchronously:', memoryDeviceId);
    // Set up device ID for API calls immediately
    setApiDeviceId(memoryDeviceId);
  }
} catch (e) {
  console.warn('Could not load device ID synchronously:', e);
}

export function useDeviceId() {
  const [deviceId, setDeviceId] = useState<string | null>(null);

  useEffect(() => {
    async function loadDeviceId() {
      // Return existing memory ID if we have one
      if (memoryDeviceId) {
        setDeviceId(memoryDeviceId);
        return;
      }

      // Try localStorage first
      try {
        const storedId = localStorage.getItem('device_id');
        if (storedId) {
          memoryDeviceId = storedId;
          setDeviceId(storedId);
          return;
        }
      } catch (e) {
        // localStorage not available (incognito) - continue to fingerprint
      }

      try {
        // Try fingerprint
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const newDeviceId = result.visitorId;

        memoryDeviceId = newDeviceId;
        try {
          localStorage.setItem('device_id', newDeviceId);
        } catch (e) {
          // localStorage failed, but we still have the ID in memory
        }
        setDeviceId(newDeviceId);
      } catch (e) {
        // If fingerprint fails, use timestamp + random as last resort
        const fallbackId = `${Date.now()}-${Math.random()
          .toString(36)
          .slice(2)}`;
        memoryDeviceId = fallbackId;
        try {
          localStorage.setItem('device_id', fallbackId);
        } catch (e) {
          // localStorage failed, but we still have the ID in memory
        }
        setDeviceId(fallbackId);
      }
    }

    loadDeviceId();
  }, []);

  return deviceId;
}
